import {
  hexToRGB,
  TEAL_300,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
import {IconJobAutomation} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
Panel.displayName = 'S.Panel';

export const Circle = styled.div`
  border-radius: 50%;
  width: 96px;
  height: 96px;
  background-color: ${hexToRGB(TEAL_300, 0.48)};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;
Circle.displayName = 'S.Circle';

export const JobAutomation = styled(IconJobAutomation)`
  width: 36px;
  height: 48px;
  color: ${TEAL_600};
`;
JobAutomation.displayName = 'S.JobAutomation';

export const Heading = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 8px;
`;
Heading.displayName = 'S.Heading';

export const Message = styled.div`
  text-align: center;
  max-width: 600px;
  font-size: 18px;
  line-height: 25px;
`;
Message.displayName = 'S.Message';
